import { NONE } from '../../../../../../forms/_common/Select';
import { rightOperandShownArray } from './constants';

export const createTest = (prevCondition, key, value) => ({
  ...prevCondition,
  [key]: value,
  ...(key === 'op' && rightOperandShownArray.includes(value) && { right: null }),
  ...(key === 'left' && prevCondition.left !== value && { right: null }),
  ...(key === 'left' && value === NONE && { [key]: '' }),
});
